import API from "./axios";
// Fetch all CAs
export const getAllCAs = async () => {
  try {
    const response = await API.get('/ca');
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to fetch CAs';
  }
};

// Assign CA to a customer
export const assignCA = async ({ customer_id, subadmin_id, agent_id, ca_id }) => {
  try {
    const response = await API.post('/ca/assign', { customer_id, subadmin_id, agent_id, ca_id });
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to assign CA';
  }
};

// Get assigned CA for a customer
export const getAssignedCA = async (customer_id) => {
  try {
    const response = await API.get(`/ca/assigned/${customer_id}`);
    return response.data;
  } catch (error) {
    if (error.response?.status === 404) return null;
    throw (error.response?.data?.message) || 'Failed to fetch assigned CA';
  }
};

export const getSentCustomers = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await API.get("/subadmin/sent-customers", {
      headers: { Authorization: `Bearer ${token}` }
    });
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || "Failed to fetch sent customers";
  }
};

export const getAssignedITRs = async () => {
  const response = await API.get('/api/assigned-itrs');
  return response.data;
};

export const getSubadminPermissions = async () => {
  try {
    const response = await API.get('/subadmin/permissions');
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to fetch subadmin permissions';
  }
};

export const getAgents = async () => {
  try {
    const response = await API.get('/subadmin/agents');
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to fetch agents';
  }
};

export const getSubadminAgentPermissions = async () => {
  try {
    const response = await API.get('/subadmin/agent-permissions');
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to fetch subadmin agent permissions';
  }
};

export const toggleAgentVerification = async (agentId) => {
  try {
    const response = await API.put(`/subadmin/agents/${agentId}/verify`);
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to toggle agent verification';
  }
};

export const getCustomersITR = async () => {
  try {
    const response = await API.get('/subadmin/customers-itr');
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to fetch customers ITR';
  }
};

export const toggleAgentEdit = async (itrId) => {
  try {
    const response = await API.put(`/subadmin/toggle-agentedit/${itrId}`);
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to toggle agent edit';
  }
};

export const assignCAtoITR = async (customerId, caId) => {
  try {
    const response = await API.put(`/subadmin/assign-ca/${customerId}`, { caId });
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to assign CA to ITR';
  }
};

export const updateCustomerBySubadmin = async (itrId, data) => {
  try {
    // Check if any attachments are files
    const hasFiles = Object.keys(data).some(key => key.startsWith('attachments_') && data[key] instanceof File);
    console.log("update customer snapshot hasFiles", hasFiles);
    if (hasFiles) {
      // Use FormData for file uploads
      const formData = new FormData();
      Object.keys(data).forEach(key => {
        if (data[key] !== null && data[key] !== undefined) {
          formData.append(key, data[key]);
        }
      });

      const response = await API.put(`/subadmin/update-customer/${itrId}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } else {
      // Use regular JSON for non-file data
      const response = await API.put(`/subadmin/update-customer/${itrId}`, data);
      return response.data;
    }
  } catch (error) {
    throw error.response?.data?.message || "Failed to update customer snapshot";
  }
}

export const reapplyITR = async (customerId) => {
  try {
    const response = await API.post(`/subadmin/reapply-itr/${customerId}`);
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to reapply ITR';
  }
};

export const rejectITR = async (itrId, comment, extra_charge = null) => {
  try {
    const response = await API.post(`/subadmin/reject-itr/${itrId}`, { comment, extra_charge });
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to reject ITR';
  }
};

export const takeITR = async (itrId) => {
  try {
    const response = await API.post(`/subadmin/take-itr/${itrId}`);
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to take ITR';
  }
};

export const getTakenITRs = async () => {
  try {
    const response = await API.get('/subadmin/taken-itrs');
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to fetch taken ITRs';
  }
};

export const getEverificationITRs = async () => {
  try {
    const response = await API.get('/subadmin-everification/list');
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to fetch everification list';
  }
};

export const updateSubadminOtpCheck = async (itrId, formData) => {
  try {
    const response = await API.put(`/subadmin-everification/otp-check/${itrId}`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to update OTP check';
  }
};

export const getRejectedITRs = async (subadminId) => {
  try {
    const response = await API.get('/subadmin/rejected-itrs', { params: { subadminId } });
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to fetch rejected ITRs';
  }
};

export const getITRHistory = async (itrId) => {
  try {
    const response = await API.get(`/payment/itr-history/${itrId}`);
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to fetch ITR history';
  }
};

export const getITRFlowHistory = async (itrId) => {
  try {
    const response = await API.get(`/subadmin/itr-flow/${itrId}`);
    return response.data;
  } catch (error) {
    throw (error.response?.data?.message) || 'Failed to fetch ITR flow history';
  }
};

